module.exports = ".mat-dialog-container{\r\n    padding: 0px!important;\r\n}"